import React, {useEffect, useRef, useState} from 'react';
import '../VendorSettings.scss';
import {connect} from 'react-redux';
import {
    setFilter,
    setPurposeConsent,
    setPurposeLegitimateInterest,
    setConsent,
    setObjectConsent,
    setAllConsentSwitch,
    setAllObjectConsentSwitch
} from '../../../../../redux/actions';
import Switch, {SwitchColor} from "../../../../Switch/Switch";
import ResponsiveList from "../../../../ResponsiveList/ResponsiveList";
import Vendor from "./Vendor";
import {allInterests, allPurposes} from "../../../../../scripts/lib/handlers";

const Vendors = props => {
    const {currentFilter, vendorsRef, availableHeight} = props;
    const {objectConsent, vendorConsent, vendorList} = props.configuration;
    const [activeVendor, setActiveVendor] = useState(-1);
    const [maxHeight, setMaxHeight] = useState(availableHeight.max);
    const listHeaderRef = useRef(null);
    const vendorsOfFilter = vendorList.vendors.filter(vendor =>
        vendor[currentFilter.filterName].includes(currentFilter.value.id)
    );

    useEffect(() => {
        if (listHeaderRef.current) {
            const {current: element} = listHeaderRef;
            const height = element.offsetHeight;
            const style = window.getComputedStyle(element);
            setMaxHeight(availableHeight.max - (height + parseInt(style.marginTop) + parseInt(style.marginBottom)));
        }
    }, [availableHeight, listHeaderRef])


    const toggleActive = (index) => {
        setActiveVendor(prevVendor => prevVendor === index ? -1 : index);
    }

    const changeAllConsent = (e) => {
        const {purposeConsent} = props.configuration;
        const switchState = e.target.checked;
        vendorsOfFilter.forEach(vendor => vendorConsent[vendor.id] = switchState);
        if (typeof props.configuration.static?.purposeConsent?.[currentFilter.value.id] !== 'boolean') {
            purposeConsent[currentFilter.value.id] = switchState;
            props.setPurposeConsent(purposeConsent);
        }
        props.setConsent(vendorConsent);
        props.setAllConsentSwitch(allPurposes(props.configuration));
    }

    const changeAllObject = (e) => {
        const {purposeLegitimateInterest: purposeLegInt} = props.configuration;
        const switchState = e.target.checked;
        vendorsOfFilter.forEach(vendor => {
            if (vendor.legIntPurposes.length) objectConsent[vendor.id] = switchState;
        });
        if (typeof props.configuration.static?.purposeLegitimateInterest?.[currentFilter.value.id] !== 'boolean') {
            purposeLegInt[currentFilter.value.id] = switchState;
            props.setPurposeLegitimateInterest(purposeLegInt);
        }
        props.setObjectConsent(objectConsent);
        props.setAllObjectConsentSwitch(allInterests(props.configuration));
    }

    const objectSwitchOnChangeHandler = (vendorId) => {
        let {objectConsent} = props.configuration;

        if (typeof props.configuration.static?.objectConsent?.[vendorId] !== 'boolean') {
            objectConsent[vendorId] = !objectConsent[vendorId];
            props.setObjectConsent(objectConsent);
        }
    }

    const consentSwitchOnChangeHandler = (vendorId) => {
        let {vendorConsent} = props.configuration;

        if (typeof props.configuration.static?.vendorConsent?.[vendorId] !== 'boolean') {
            vendorConsent[vendorId] = !vendorConsent[vendorId];
            props.setConsent(vendorConsent);
        }
    }

    const vendorData = vendorsOfFilter.map((vendor, index) => ({
        index, vendor,
        labels: props.currentLanguage.text.labels,
        states: {
            isActive: activeVendor === index,
            isConsented: !!(props.configuration.vendorConsent?.[vendor.id]),
            isObjected: !!(props.configuration.objectConsent?.[vendor.id])
        },
        handlers: {
            onClick: toggleActive.bind(this, index),
            onConsent: consentSwitchOnChangeHandler.bind(this, vendor.id),
            onObject: objectSwitchOnChangeHandler.bind(this, vendor.id)
        }
    }));

    return (
        <React.Fragment>
            <div id="vendorListHeader" ref={listHeaderRef}>
                <h2>{props.currentLanguage.text.labels.vendors}</h2>
                <span id="selectAll"
                      className="label">{props.currentLanguage.text.selectAll || '(de)select all:'}</span>
                <Switch label={props.currentLanguage.text.labels.consent} classNames={["consent"]}
                        isChecked={vendorsOfFilter.every(vendor => vendorConsent[vendor.id] === true)}
                        changeHandler={changeAllConsent}/>
                <Switch label={props.currentLanguage.text.labels.legitimateInterest.replace(/\s/, '\n')}
                        classNames={["leg-int"]} changeHandler={changeAllObject} color={SwitchColor.ORANGE}
                        isChecked={vendorsOfFilter
                            .filter(vendor => !!vendor.legIntPurposes.length)
                            .every(vendor => objectConsent[vendor.id] === true)}/>
            </div>
            <div id="vendorList" ref={vendorsRef}>
                <ResponsiveList itemData={vendorData} ItemElementType={Vendor}
                                availableHeight={{...availableHeight, max: maxHeight}}/>
            </div>
        </React.Fragment>
    );
};

const mapStateToProps = state => {
    return {...state};
}

export default connect(mapStateToProps, {
    setFilter,
    setPurposeConsent,
    setPurposeLegitimateInterest,
    setConsent,
    setObjectConsent,
    setAllConsentSwitch,
    setAllObjectConsentSwitch
})(Vendors);